<template>
    <div id="ii-introduction">
        <div class="row wrap">
            <input-text :label="$t('Title')" :placeholder="$t('Title')" v-model="interactiveImage.intro_title" @change="interactiveImage.patch('intro_title')"/>
            <input-text :label="$t('Subtitle')" :placeholder="$t('Subtitle')" v-model="interactiveImage.intro_subtitle" @change="interactiveImage.patch('intro_subtitle')"/>
            <input-textarea :label="$t('Text')" :placeholder="$t('Text')" v-model="interactiveImage.intro_text" @change="interactiveImage.patch('intro_text')"/>
            <input-checkbox :label="$t('Hide intro')" v-model="interactiveImage.hide_intro" @change="interactiveImage.patch('hide_intro')"/>
            <input-media :label="$t('Image')" v-model="interactiveImage.intro_image" :storieId="interactiveImage.getStoryId()" @change="interactiveImage.patch('intro_image')"/>
        </div>
    </div>
</template>

<script>
import InputText from "@/modules/input/input-text";
import InputTextarea from "@/modules/input/input-textarea";
import InputMedia from "@/modules/input/input-media";
import {interactiveImage} from "@/class/interactive-image/interactiveImage";
import InputCheckbox from "@/modules/input/input-checkbox";
export default {
    name: "InteractiveImage_Introduction",
    components: {InputCheckbox, InputMedia, InputTextarea, InputText},
    props:{
        interactiveImage:{type:Object,default:() => new interactiveImage()}
    },
    
}
</script>
